import { createSlice } from "@reduxjs/toolkit";
import { getUnitesStatuses } from "./unitThunk";
const unitStatusSlice = createSlice({
  name: "unites",
  initialState: {
    status: null,
    unitStatutes: {},
  },
  extraReducers: {
    [getUnitesStatuses.pending]: (state) => {
      state.status = "loading";
    },
    [getUnitesStatuses.fulfilled]: (state, { payload }) => {
      state.status = "success";
      state.unitStatutes = payload;
    },
    [getUnitesStatuses.rejected]: (state, _error) => {
      state.status = "failed";
      state.unitStatutes = {};
    },
  },
});

export default unitStatusSlice.reducer;
